import React from "react";
import styles from "./indicator-text.module.scss";

import BlueIndicatorIcon from "./icons/blue-indicator-icon.svg";
import GreenIndicatorIcon from "./icons/green-indicator-icon.svg";
import OrangeIndicatorIcon from "./icons/orange-indicator-icon.svg";
import RedIndicatorIcon from "./icons/red-indicator-icon.svg";
import InfoIndicatorIcon from "./icons/info-indicator-icon.svg";
import { useI18N } from "@src/language/language-context";

interface IndicatorTextPropTypes {
  text: string;
  variant: string;
}

const getIcon = (variant) => {
  const iconByText = {
    blue: BlueIndicatorIcon,
    green: GreenIndicatorIcon,
    orange: OrangeIndicatorIcon,
    red: RedIndicatorIcon,
    info: InfoIndicatorIcon,
  };

  return iconByText[variant];
};

export const IndicatorText = ({ text, variant }: IndicatorTextPropTypes) => {
  const i18n = useI18N();
  const texts = {
    indicatorTextIconAltText: i18n(
      "modules.indicatorText.indicatorTextIconAltText",
    ),
  };
  return (
    <div className={styles["indicator-text"]}>
      <img
        className={styles["indicator-text__icon"]}
        src={getIcon(variant)}
        alt={texts.indicatorTextIconAltText}
      />
      <span
        className={`${styles["indicator-text__text"]} ${
          styles[`indicator-text__text--${variant}`]
        }`}
      >
        {text}
      </span>
    </div>
  );
};
